module.exports = __webpack_public_path__ + "img/library.25bc37b2.svg";